
























import { defineComponent } from "@vue/composition-api";
import { CurrencyCost, PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getCostByCurrency } from "@/lib/moneyHelpers";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "ContentFeedPrice",
  components: { FormatMoney, BaseIcon },
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    subscriptionLevels: { type: Array as () => SubscriptionLevel[], required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },
  computed: {
    isFree(): boolean {
      return this.contentFeed.subscriptionLevelId === "0" && this.contentFeed.pricePackageId === "0";
    },
    subscriptionCost(): CurrencyCost | null {
      const level = this.subscriptionLevels.find(level => level.id === this.contentFeed.subscriptionLevelId);
      if (!level || !level.pricePackage) return null;
      return getCostByCurrency(level.pricePackage) || null;
    },
    subscriptionPrice(): number {
      return this.subscriptionCost?.cost ?? 0;
    },
    subscriptionCurrencyCode(): string | undefined {
      return this.subscriptionCost?.currency;
    },
    oneTimeCost(): CurrencyCost | null {
      const paymentPackage = this.paymentPackages.find(pack => pack.id === this.contentFeed.pricePackageId);
      if (!paymentPackage) return null;
      return getCostByCurrency(paymentPackage) || null;
    },
    oneTimePrice(): number {
      return this.oneTimeCost?.cost ?? 0;
    },
    oneTimeCurrencyCode(): string | undefined {
      return this.oneTimeCost?.currency;
    },
  },
});
